export default {
    namespaced: true,
    state: {
        cartVendors: window.Telemart.cartVendors,
        totalQty: window.Telemart.totalQty,
        subTotal: window.Telemart.subTotal,
        paymentMethodDiscount: 0,
        paymentMethodDiscountLabel: null,
        totalCount: window.Telemart.cartCount,
        totalInsurance: window.Telemart.totalInsurance,
        totalSaving: window.Telemart.cartSaving,
        discount: window.Telemart.discount,
        shippingCharges: 0,
        processingFee: 0,
        isServiceCharges: 0,
        canCheckout: window.Telemart.canCheckout,
        isExpressCart: window.Telemart.isExpressCart,
        isKarachi: false,
        productLimit: 0,
        cityId: null
    },
    getters: {
        getCartVendors: state => state.cartVendors,
        getCartTotalQty: state => state.totalQty,
        getCartSubtotal: state => state.subTotal,
        getPaymentMethodDiscount: state => state.paymentMethodDiscount,
        getPaymentMethodDiscountLabel: state => state.paymentMethodDiscountLabel,
        getProcessingFee: state => state.processingFee,
        getShippingCharges: state => state.shippingCharges,
        getInsuranceCharges: state => state.totalInsurance,
        getCartSaving: state => state.totalSaving,
        getDiscount: state => state.discount,
        getIsServiceCharge: state => state.isServiceCharges,
        cartCount: state => state.totalCount,
        getIsExpressCart: state => state.isExpressCart,
        getCanCheckout: state => state.canCheckout,
        getIsKarachi: state => state.isKarachi,
        getProductLimit: state => state.productLimit,
        getCityId: state => state.cityId,
    },
    mutations: {
        SET_CART_VENDORS: (state, data) => state.cartVendors = data,
        SET_LIMIT_QTY: (state, data) => state.productLimit = data,
        SET_CART_TOTAL_QTY: (state, data) => state.totalQty = data,
        SET_CART_SUBTOTAL: (state, data) => state.subTotal = data,
        SET_TOTAL_COUNT: (state, data) => state.totalCount = data,
        SET_DISCOUNT: (state, data) => state.discount = data,
        SET_TOTAL_SAVING: (state, data) => state.totalSaving = data,
        SET_PROCESSING_FEE: (state, data) => state.processingFee = data,
        SET_SHIPPING_CHARGES: (state, data) => state.shippingCharges = data,
        SET_INSURANCE_CHARGES: (state, data) => state.totalInsurance = data,
        PUT_CART_SUBTOTAL: (state, data) => state.subTotal = data,
        SET_IS_EXPRESS_CART: (state, data) => state.isExpressCart = data,
        SET_IS_SERVICE_CHARGES: (state, data) => state.isServiceCharges = data,
        SET_IS_KARACHI: (state, data) => state.isKarachi = data,
        SET_CAN_CHECKOUT: (state, data) => state.canCheckout = data,
        SET_CART_PAYMENT_METHOD_DISCOUNT: (state, data) => {
            state.paymentMethodDiscountLabel = data.paymentMethodDiscountLabel;
            state.paymentMethodDiscount = data.paymentMethodDiscount;
        },
        RESET_CART_PAYMENT_METHOD_DISCOUNT: (state) => {
            state.paymentMethodDiscountLabel = null;
            state.paymentMethodDiscount = 0;
        },
        INCREASE_TOTAL_QTY: (state) => state.totalQty++,
        DECREASE_TOTAL_QTY: (state) => state.totalQty--,
        ADD_CITY_ID: (state, cityId) => state.cityId = cityId,
    },
    actions: {
        GET_CART: ({commit}) => new Promise((resolve, reject) => {
            axios.get('/api/cart')
                .then(({data}) => {
                    commit('SET_CART_VENDORS', data.cartVendors);
                    commit('SET_CART_TOTAL_QTY', data.totalQty);
                    commit('SET_CART_SUBTOTAL', data.subTotal);
                    commit('SET_TOTAL_COUNT', data.cartCount ?? 0);
                    commit('SET_TOTAL_SAVING', data.totalSaving);
                    commit('SET_INSURANCE_CHARGES', data.insurancePrice);
                    commit('SET_DISCOUNT', data.discount);
                    commit('SET_IS_EXPRESS_CART', data.isExpressCart);
                    commit('SET_CAN_CHECKOUT', data.canCheckout);
                    resolve();
                })
                .catch((err) => {
                    commit('SET_ERROR', err);
                    reject();
                });
        }),
        GET_PAYMENT_METHOD_DISCOUNT: ({commit}, data) => new Promise((resolve, reject) => {

            commit('RESET_CART_PAYMENT_METHOD_DISCOUNT');

            axios.post('/api/cart/paymentMethodDiscount', data)
                .then(({data}) => {
                    commit('SET_CART_PAYMENT_METHOD_DISCOUNT', data);
                    resolve();
                })
                .catch((err) => {
                    commit('SET_ERROR', err);
                    reject();
                });
        }),
        ADD_PROCESSING_FEE: ({commit, state}, data) => new Promise((resolve, reject) => {
            commit('SET_IS_SERVICE_CHARGES', 1)
            commit('SET_PROCESSING_FEE', Math.ceil((state.subTotal / 100) * data.service_charges));
        }),
        ADD_TAX_FEE: ({commit, state}, data) => new Promise((resolve, reject) => {
            commit('SET_IS_SERVICE_CHARGES', 0)
            commit('SET_PROCESSING_FEE', Math.ceil((state.subTotal / 100) * data.tax));
        }),
        ADD_SHIPPING_FEE: ({dispatch, commit, state}, data) => {
            const city_id = data.city_id
            axios.post('/api/cart/shipping', {city_id})
                .then(({data}) => {
                    commit('ADD_CITY_ID', city_id);
                    commit('SET_SHIPPING_CHARGES', data);
                    dispatch('UPDATE_CART');
                }).catch(console.log);
        },
        CHECK_IF_KARACHI: ({commit, state}, data) => {
            commit('SET_IS_KARACHI', (data.city_id === 105));
        },

        LIMIT_QTY: ({commit, state}, data) => {
            commit('SET_LIMIT_QTY', data);
        },
        INCREASE_QTY: ({dispatch, commit}, data) => new Promise((resolve, reject) => {
            axios.put('/api/cart/update', data)
                .then(({data}) => {
                    commit('INCREASE_TOTAL_QTY');
                    dispatch('UPDATE_CART');
                    resolve(data.message);
                })
                .catch(reject);
        }),
        DECREASE_QTY: ({dispatch, commit}, data) => new Promise((resolve, reject) => {
            axios.put('/api/cart/update', data)
                .then(({data}) => {
                    commit('DECREASE_TOTAL_QTY');
                    dispatch('UPDATE_CART');
                    resolve(data.message);
                })
                .catch(reject);
        }),
        UPDATE_CART: ({commit}) => new Promise((resolve, reject) => {
            axios.get('/api/cart/price')
                .then(({data}) => {
                    commit('PUT_CART_SUBTOTAL', data.total);
                    commit('SET_TOTAL_SAVING', data.totalSaving);
                    commit('SET_DISCOUNT', data.discount);
                    commit('SET_INSURANCE_CHARGES', data.insurancePrice);
                    resolve();
                })
                .catch((err) => {
                    commit('SET_ERROR', err);
                    reject();
                });
        }),
        REMOVE_CART: ({dispatch, commit}, data) => new Promise((resolve, reject) => {
            axios.put('/api/cart/remove', data)
                .then(({data}) => {
                    dispatch('GET_CART');
                    resolve(data.message);
                })
                .catch((err) => {
                    commit('SET_ERROR', err);
                    reject();
                });
        }),
    }
};
